import React from 'react';
import {createFragmentContainer, graphql} from "react-relay";
import {Link} from "react-router-dom";


function TriggerReason({reason}) {
  if (!reason) {
    return 'Not available (deleted)'
  }
  if (reason.__typename === 'DataPullRunNode') {
    return <div>
      <Link to={`/system/data-pull-runs/${reason.id}`}>
        <i className="fas fa-arrow-right mr-2"/>
        Data pull
      </Link>
      <br/>
      <small className={'text-muted'}>received {reason.finishedDate}</small>
    </div>
  } else if (reason.__typename === 'IngestedFileNode') {
    return <div>
      <Link to={`/system/ingested-files/${reason.systemId}`}>
        Ingested File
      </Link> <br/>
      <small className={'text-muted'}>received {reason.timestamp}</small>
    </div>
  }

  return <p className={'text-danger'}>Unknown</p>
}

export default createFragmentContainer(
    TriggerReason,
    {
      reason: graphql`
        fragment TriggerReason_reason on Node {
          id
          __typename
          ... on IngestedFileNode {
            systemId
            file
            tags
            timestamp
            brand {
              ...SmallInlineBrandDisplay_brand
            }
            retailer {
              ...SmallInlineRetailerDisplay_retailer
            }
          }
          ... on DataPullRunNode {
            id
            state
            finishedDate
            dataPull {
              id
            }
          }
        }
      `
    }
)